import { RouterProvider } from 'react-router';

import './config/i18n';
import { router } from './config/router';
import { AppProviders } from './providers';

function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}

export default App;
